import type { SceneDef } from '../types.js';

export function getSceneBackgroundId(scene: SceneDef): string {
  return scene.backgroundReuseId ?? scene.id;
}
